
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import EditReturnOrder from './edit-returnorder.vue'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);


    class PageOrderRequest extends PageRequest {
        //WarehouseOrderStatus?: number ;
        //WarehouseOrderPackageStatus?: number;
        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        storeId?: number;
        EndTime?: Date;
        tradeNo: string;
        PlatformType?: number;
        productorderStatus?: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            //this.PlatformType = 0;
        }
    }


    @Component({
        name: "frontabroadorder",
        components: { EditReturnOrder }
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        storeaddressList: Array<storeaddressInfo> = [];
        editreturnorderModel: boolean = false;
        productorderList = Enums.getEnum(Enums.ProductOrderStatus, true);
        get list() {
            return this.$store.state.frontabroadorder.list;
        };
        get loading() {
            return this.$store.state.frontabroadorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('frontabroadorder/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontabroadorder/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.frontabroadorder.currentPage = 1;
            this.getpage();
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'frontabroadorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);

        }
        async InputReturnOrder(data: any) {
            this.$store.state.fontoverseasreturnorders.id = data.id;
            this.$store.state.fontoverseasreturnorders.orderNumber = data.orderNumber;
            this.editreturnorderModel = true;
        }
        get pageSize() {
            return this.$store.state.frontabroadorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontabroadorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontabroadorder.currentPage;
        }
        async operationData(name: any, data: any) {
            if (name == '撤销') {
                await this.$store.dispatch({
                    type: 'frontabroadorder/cancelOrder',
                    data: { orderId: data.id }
                });
                this.getpage();
            } else if (name == '标记为正常') {
                await this.$store.dispatch({
                    type: 'frontabroadorder/normalOrder',
                    data: { id: data.id }
                });
                this.getpage();
            } else if (name == '查看详情') {
                await this.$store.dispatch({
                    type: 'frontabroadorder/getOrder',
                    data: { id: data.id }
                });
                this.$store.state.frontabroadorder.orderStatus = data.orderStatus;
                this.$store.state.frontabroadorder.packageStatus = data.packageStatus;
                this.$router.push({ name: 'abroadorderDetail' });
            }
        }

        columns = [
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            }, {
                title: '订单状态',
                width: 100,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            },
            {
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "异常图片"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '备注',
                width: 200,
                key: 'reMark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
                    )
                }
            }, {
                title: '包裹状态',
                width: 90,
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            }, {
                title: '产品订单状态',
                width: 80,
                key: 'productOrderStatus',
                render: (h: any, params: any) => {
                    var color = 'red';
                    if (params.row.productOrderStatus == 3 || params.row.productOrderStatus == 4) {
                        color = 'green';
                    }
                    if (params.row.productOrderStatus != 2) {
                        return h('div', [h('p', { style: { color: color } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                    }
                    else {
                        return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                        )
                    }

                }
            }, {
                title: '创建时间',
                key: 'createTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },
            {
                title: '打包时间',
                key: 'packedTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.packedTime ? DateUtils.formatLongDate(new Date(params.row.packedTime)) : '');
                }
            },
            {
                title: '商品信息',
                width: 300,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), h('h2', { style: { color: "red", display: "inline-block" } }, item.count)]);
                    }));
                }
            },
            {
                title: '平台物流号',
                key: 'tradeNo',
                width: 130,
            },
            {
                title: '退件订单编号',
                width: 120,
                key: 'returnNumber',
            },
            {
                title: '快递单号',
                key: 'logistics',
                width: 150,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {

                        var productOrderStatusName = "";
                        if (params.row.productOrderStatus != null) {
                            productOrderStatusName = Enums.ProductOrderStatus.filter(function (dataItem) { return dataItem.value == params.row.productOrderStatus })[0].name;
                        }
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn || productOrderStatusName == "已取消" || packagestus=="已撤销") {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = "-" + item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span>' + shelfNumber + '</a>'
                            }
                        });

                    }));
                }
            },
            {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            },
            {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },
            {
                title: '打包袋金额',
                key: 'sackTotalAmount',
                width: 80,
            },
            {
                title: 'SKU金额',
                key: 'skuTotalAmount',
                width: 80,
            },
            {
                title: '操作',
                width: 120,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var _this = this;
                    var menu = [];
                    var data = params.row;
                    if (params.row.packageStatus == 0 && params.row.orderStatus == 0 || params.row.orderStatus == -1) {
                        menu.push("撤销");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("标记为正常");
                    }
                    menu.push("查看详情");
                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    },
                                    style: {
                                        marginTop: '5px',
                                        height: '30px',
                                        width: '85px',
                                    },

                                }),
                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )]),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                                display: (data.packageStatus == 4 && data.orderStatus == 0) ? "inline-block" : "none",
                            },
                            on: {
                                click: () => {
                                    this.InputReturnOrder(data);

                                }
                            }

                        }, "编辑退件订单"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                                        this.$store.commit('frontabroadorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),

                    ]);

                }
            }
        ]
        async created() {
            //var abnormal = abp.getQueryVariable("abnormal");
            //if (abnormal && abnormal == 'true') {
            //    this.pagerequest.orderStatus = -1;
            //}
            this.getpage();
            this.getData();
        }

    }
